module.exports = __webpack_public_path__ + "media/images/user/favicons/favicon-e1a4a1899b3fa69aee938403a6ae1edb.ico";